/*
 * @Description: 应用间的store
 * @Date: 2021-09-18 15:15:46
 */
import { getToken } from '@/tools/auth';
import { getStorage } from '@/tools/storage';
import { initGlobalState } from 'qiankun';
import { middlewareHomeProject } from '../middleware/home-project';
import v2Store from '@/store/index.js';
import Vue from 'vue';

// 父应用的初始state
const initialState = Vue.observable({
  ignore: 'master',
  token: getToken(),
  isMaster: v2Store.getters.isMaster,
  user: getStorage('user') || {
    name: 'xrk'
  },
  middlewareHomeProject
});

const store = initGlobalState(initialState); // onGlobalStateChange setGlobalState offGlobalStateChange

/**
 * @description: 监听更变后的值并同步修改入state中
 * @param {any} 更变后的值
 * @param {any} 更变前的值
 * @return {void}
 */
store.onGlobalStateChange((newState, preState) => {
  console.log(
    'main change',
    JSON.stringify(newState),
    JSON.stringify(preState)
  );
  // 需手动赋值
  for (let key in newState) {
    initialState[key] = newState[key];
  }
});

/**
 * @description: 新增 获取state下的属性
 * @param {string} 有key，表示取globalState下的某个子级对象。 无key，表示取全部
 * @return {any} value或者state
 */
store.getGlobalState = key => {
  return key ? initialState[key] : initialState;
};

export default store;
